import { render } from "./BlockSeparator.vue?vue&type=template&id=56dfdce8"
import script from "./BlockSeparator.vue?vue&type=script&lang=js"
export * from "./BlockSeparator.vue?vue&type=script&lang=js"

import "./BlockSeparator.vue?vue&type=style&index=0&id=56dfdce8&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__